import { StylableButton } from "common/Buttons/Button";
import styled from "styled-components";
import { ACTION_BUTTON_MARGIN, ACTION_BUTTON_SIZE } from "common/constants";

const ActionButton = styled(StylableButton).attrs({
  shape: "circle",
  size: "large",
  type: "primary",
})`
  &&& {
    position: absolute;
    bottom: ${ACTION_BUTTON_MARGIN}px;
    right: 16px;
    width: ${ACTION_BUTTON_SIZE}px;
    height: ${ACTION_BUTTON_SIZE}px;
    z-index: 2;
  }
`;

export default ActionButton;
